<div [class]="this.filterTerm == '' ? 'treeView' : 'treeView filtered'">
  <kendo-treeview #treeview
                  kendoTreeViewCheckable
                  kendoTreeViewExpandable
                  kendoTreeViewHierarchyBinding
                  textField="text"
                  childrenField="items"
                  (checkedChange)="handleChecking($event)"
                  [(checkedKeys)]="checkedKeys"
                  [expandOnFilter]="{ expandedOnClear: 'initial', maxAutoExpandResults: -1 }"
                  [filter]="filterTerm"
                  [filterSettings]="{
                    ignoreCase: true,
                    mode: 'strict'
                  }"
                  [nodes]="dataItems"
                  [loadOnDemand]="false">
    <ng-template kendoTreeViewNodeTemplate let-dataItem let-index="index">
      <img *ngIf="dataItem.image"
           [src]="imagePathPrefix + dataItem.image" alt=">" />
      {{ dataItem.text }}
    </ng-template>
  </kendo-treeview>
</div>
